module.exports = __webpack_public_path__ + "static/media/Avatar-11.90d2f6ad.png";